import { number, largerEq, smaller, sum, multiply, divide, round, ceil } from "mathjs";
import Vue from "vue";
const decimals = 2;

export function markup(price, calculate_display_price = true) {
  const mu = JSON.parse(atob(Vue.prototype.$config.mu));
  const markups = mu["DEFAULT"] || [];
  const mu_display_percent = mu.DISPLAY ? mu.DISPLAY.p : 0;
  const customer_markup = number(mu.ADD.p || 0.1);

  let pricerange_markup = 0;
  let mu_percent = customer_markup;

  markups.forEach((m) => {
    if (largerEq(number(price), number(m.min))) {
      pricerange_markup = number(m.p);
    } else {
      return;
    }
  });

  if (Vue.prototype.$config.forced_mu) {
    // caso CONFIRM -> markup forzato da confirm()
    mu_percent = JSON.parse(atob(Vue.prototype.$config.forced_mu));
  } else {
    mu_percent = round(sum(pricerange_markup, customer_markup), 3); // percentuale markup 3 decimali
  }

  const markup = round(multiply(price, mu_percent), decimals);
  let live_price = round(sum(price, markup), decimals);

  if (smaller(live_price, price)) {
    live_price = price;
  }

  let display_price = live_price;
  if (calculate_display_price) {
    const display_markup = round(multiply(price, mu_display_percent), decimals);
    display_price = round(sum(price, display_markup), decimals);
  }

  /*window.console.table({
    price: price,
    mu_percent: mu_percent,
    markup: markup,
    live_price: live_price,
    display_price: display_price,
  })*/

  return {
    markup, // ammontare del markup
    live_price: round_up(live_price), // markup su prezzo netto
    display_price: round_up(display_price), // markup "finto" su prezzo commissionabile
  };
}

export function round_up(price, decimals) {
  decimals = decimals || 0;
  return ceil(price * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

const ADULT_TYPES = new Set(['ADULT', 'ADT', 'MR', 'MS']);
const CHILD_TYPES = new Set(['CHILD', 'CHD']);
const INFANT_TYPES = new Set(['INFANT', 'INF']);

export const get_passenger_type = (passenger) => {
  if (!passenger) return '';
  if (passenger.passengerType) return passenger.passengerType;
  const { fields = [] } = passenger.details || {};
  const type_pax = fields.find((f) => f.name === 'type_pax');
  return (type_pax && type_pax.value) || '';
};

export const is_adult = (passenger) => ADULT_TYPES.has(get_passenger_type(passenger));
export const is_child = (passenger) => CHILD_TYPES.has(get_passenger_type(passenger));
export const is_infant = (passenger) => INFANT_TYPES.has(get_passenger_type(passenger));

/**
 * Check whether the occupancy array has at least one room with adults > 0.
 *
 * @param {Array} occupancy - The occupancy array from the store
 * @returns {boolean}
 */
export const has_valid_occupancy = (occupancy) => {
  if (!Array.isArray(occupancy) || occupancy.length === 0) {
    return false;
  }
  return occupancy[0].adults > 0;
};

/**
 * Check whether a booking includes flights.
 *
 * Accepts any of the payloads that carry the answer, because each stage of the
 * flow hands it over in a different envelope:
 *   - quote            → { services: { flights } }        (both flows; the
 *                         only-stay normalizer guarantees the empty array)
 *   - confirm response → { orderData: { services: { flights } } }  (vacanze),
 *                         or a flat sololandVoucher with no services at all
 *   - a bare services object, as passed down to package-summary / services
 *
 * @param {Object} source - quote, confirm response, or services object
 * @returns {boolean}
 */
export const has_flights = (source) => {
  const { services, orderData = {} } = source || {};
  const { flights = [] } = services || orderData.services || source || {};
  return flights.length > 0;
};

/**
 * Per-person share of an already marked-up price.
 *
 * @param {number|string} display_price - price with markup already applied
 * @param {number} pax_count
 * @returns {number} 0 when pax_count is missing or not a positive number
 */
export const price_per_person = (display_price, pax_count) => {
  const count = Number(pax_count);
  if (!isFinite(count) || count <= 0) {
    return 0;
  }
  const price = Number(display_price);
  if (!isFinite(price)) {
    return 0;
  }
  return round(divide(price, count), decimals);
};
